// extracted by mini-css-extract-plugin
export default {"reloadPage":"ReloadPage_reloadPage__nxLUj","button":"ReloadPage_button__Rp6c2"};